<div class="mb-2 flex items-center justify-between">
  <nz-radio-group [ngModel]="currentFilter" (ngModelChange)="changeFilter($event)">
    <label nz-radio-button nzValue="all">All {{ totalNotifications || 0 }}</label>
    <label nz-radio-button nzValue="unread">Unread {{ unreadCount || 0 }}</label>
  </nz-radio-group>
  <button nz-button nzType="default" type="button" nzShape="circle" (click)="refreshNotifications()">
    <i nz-icon nzType="reload"></i>
  </button>
</div>

<div class="desktop:w-96 desktop:h-80 tablet:w-96 tablet:h-80 phone:w-80 phone:h-80 mini:w-80 mini:h-80 overflow-y-auto" (scroll)="onScroll($event)">
  @if (activeNotifications.length > 0) {
    <nz-list [nzLoading]="initLoading">
      @for (group of activeNotifications; track group.date) {
        <div class="date-section mb-4">
          <h4 class="text-gray-600 text-sm font-medium mb-2 sticky top-0 w-full bg-white z-50">{{ group.date }}</h4>
          @for (item of group.items; track item.notification_id) {
            <nz-list-item class="px-3" [ngClass]="item.ismarked === true ? 'readMarked' : 'unread'">
              <nz-list-item-meta (click)="item.routing_id ? routeToComponent(item) : null">
                <nz-list-item-meta-title>
                  <div class="flex items-center justify-between mb-1">
                    <div class="flex items-center gap-1">
                      <span class="text-xs text-grey-500">{{ item.notification_type }}</span>
                      @if (item.application_name) {
                        <span class="px-2 py-[2px] rounded-full text-[10px] font-medium bg-blue-50 text-blue-600 border border-blue-200 ml-1">
                          {{ item.application_name | titlecase }}
                        </span>
                      }
                    </div>
                    @if (item.ismarked !== true) {
                      <button nz-button nzType="link" nzSize="small" class="mark-read-btn" (click)="$event.stopPropagation(); markAsRead(item)">Mark as read</button>
                    }
                  </div>
                  @if (item.routing_id) {
                    <a class="notification-body">{{ item.notification }}</a>
                  } @else {
                    <p class="notification-body">{{ item.notification }}</p>
                  }
                  <p class="text-grey-100 text-[11px]">
                    @if (group.date === 'Today') {
                      {{ item.created_at | relativeTime }}
                    } @else {
                      {{ item.created_at | gDate: 'hh:mm a' }}
                    }
                  </p>
                </nz-list-item-meta-title>
              </nz-list-item-meta>
            </nz-list-item>
          }
        </div>
      }
      @if (initLoading) {
        <div class="text-center py-4">
          <nz-spin></nz-spin>
        </div>
      }
    </nz-list>
  } @else {
    @if (initLoading) {
      <div class="flex items-center justify-center h-full py-4">
        <nz-spin></nz-spin>
      </div>
    } @else {
      <div class="h-full w-full flex items-center justify-center">
        <nz-empty [nzNotFoundContent]="currentFilter === 'all' ? 'No notifications available' : 'No unread notifications'"></nz-empty>
      </div>
    }
  }
</div>
